module.exports = __webpack_public_path__ + "img/rocketleague_champions.93e86cc4.jpg";